export default "__VITE_ASSET__AnGTVLYP__"